import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  authSelector,
  setSelectedCategories,
} from '../../store/slices/auth-slice';

const ShopCategories = ({ categories, getSortParams }) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const { selectedCategories } = useSelector(authSelector);

  const handleCategoryChange = (event, categoryId) => {
    let updatedCategories = [...(selectedCategories || [])];

    if (event.target.checked) {
      if (!updatedCategories.includes(categoryId)) {
        updatedCategories.push(categoryId);
      }
    } else {
      updatedCategories = updatedCategories.filter(
        (item) => item !== categoryId
      );
    }

    if (categoryId === '') {
      updatedCategories = [];
    }

    dispatch(setSelectedCategories(updatedCategories));
  };

  return (
    <div className="sidebar-widget">
      <h4 className="pro-sidebar-title">{t("Categories")} </h4>
      <div className="sidebar-widget-list mt-30">
        {categories ? (
          <ul>
            <li>
              <label className="sidebar-widget-list-left">
                <input
                  type="checkbox"
                  className={selectedCategories?.includes('') ? 'active' : ''}
                  onChange={(e) => handleCategoryChange(e, '')}
                  checked={selectedCategories?.length === 0}
                />
                <span className="checkmark" />
                <span className="checkmark-text">{t("All Categories")}</span>
              </label>
            </li>
            {categories.map((category, key) => {
              return (
                <li key={key}>
                  <label className="sidebar-widget-list-left">
                    <input
                      type="checkbox"
                      className={
                        selectedCategories?.includes(category?.productCategoryId) ? 'active' : ''
                      }
                      onChange={(e) => handleCategoryChange(e, category?.productCategoryId)}
                      checked={selectedCategories?.includes(category?.productCategoryId)}
                    />{' '}
                    <span className="checkmark" />
                    <span className="checkmark-text">{category?.categoryName}</span>
                  </label>
                </li>
              );
            })}
          </ul>
        ) : (
          t('No categories found')
        )}
      </div>
    </div>
  );
};

ShopCategories.propTypes = {
  categories: PropTypes.array,
  getSortParams: PropTypes.func,
};

export default ShopCategories;
